import { render, staticRenderFns } from "./PageSelector.vue?vue&type=template&id=8166510e&scoped=true"
import script from "./PageSelector.vue?vue&type=script&lang=js"
export * from "./PageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8166510e",
  null
  
)

export default component.exports